import React from 'react'
import styles from './personalCard.module.css'

class PersonalCard extends React.Component {
  render() {
    return (
      <div className={styles.personalCard}>
        <figure className={styles.image}>{this.props.children}</figure>
        <figcaption className={styles.figcaption}>
          <span className={styles.name}>{this.props.name}</span>
          <span className={styles.position}>{this.props.position}</span>
        </figcaption>
      </div>
    )
  }
}

export default PersonalCard
